import { useQuery } from '@tanstack/react-query';
import { getRelativeURLWithParams, replaceParamsInURL } from 'utils/url';
import { REQUEST_ID_HEADER } from 'constants/headers';
import { getRequestId } from 'utils/requestId';
import { dealerCustomer } from './types';
import { DEALER_CUSTOMERS } from 'constants/endpoints.api';

type DealerCustomerQuery = {
  data: {
    customerNumber: string;
    storeId: string;
  };
  storeId: string;
  locale: string;
};

export const useDealerCustomerQuery = ({
  data,
  storeId,
  locale
}: DealerCustomerQuery) =>
  useQuery<dealerCustomer>({
    // TODO: dependencies missing in queryKey: storeId, data[DEALER_INPUT_ADDRESS], data[DEALER_INPUT_CITY], data[CUSTOMER_NUMBER_INPUT_NAME], data[DEALER_INPUT_ZIP_CODE]
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['dealerCustomer'],
    queryFn: async () => {
      // this is the relative url that will tell expose the service from the browser
      const partialUrl = replaceParamsInURL(DEALER_CUSTOMERS, {
        customerNumber: data.customerNumber
      });
      /*
      TODO - Input Validation
      storeId, customerNumber: should be numerical values.
      locale: should be a string with letters and '_' (localExample = 'es_MX')
    */
      const url = getRelativeURLWithParams(partialUrl, {
        storeId: data.storeId || storeId,
        locale
      });

      const response = await fetch(url, {
        headers: { [REQUEST_ID_HEADER]: getRequestId() }
      });

      if (response.ok) {
        return response.json();
      } else {
        throw new Error(`Response not OK: ${response.status}: ${response.url}`);
      }
    },
    enabled: false
  });
